module.exports = __webpack_public_path__ + "static/media/02-1-galeria-05-perisur@2x.d4be9657.jpg";